export default __webpack_public_path__ + "static/media/checkbox.eee22ce0.svg";